<template>
  <Base>
    <template v-slot:toolbar>
      <div id="kt_toolbar" class="toolbar">
        <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    {{ trans("Dashboard") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>
          <div class="d-flex align-items-center py-1" v-if="campaign.id">
            <router-link :to="{ name: 'campaign-jobs', params: { id: campaign.id } }" class="btn btn-sm btn-light-info">
              <i class="fad fa-history me-1"></i>
              Voir les logs
            </router-link>
          </div>
        </div>
      </div>
    </template>

    <template #content>
      <div class="fs-2 my-5 fw-bolder">{{ campaign.name }}</div>

      <p>
        {{ campaign.description }}
      </p>

      <div class="card mb-5">
        <div class="card-body">
          Déclencheurs
          <div class="py-10 d-flex gap-5 align-items-center flex-wrap">
            <div v-for="trigger in campaign.triggers" :key="trigger.id" class="border-dashed px-10 py-2 rounded bg-secondary text-center" @dblclick="editTrigger(trigger)">
              <div class="text-uppercase fw-bolder">
                {{ trigger.api }}
              </div>
              <div>
                {{ trigger.event }}
              </div>
            </div>
            <div class="btn btn-primary btn-icon" @click="addTrigger">
              <i class="fad fa-plus"></i>
            </div>
          </div>
        </div>
      </div>
      <b-card class=" h-100">


        <div class="d-flex flex-column align-items-center">

          <template v-if="event || campaign.actions.length > 0">
            <template v-for="(item, index) in campaign.actions">
              <div class="my-5 position-relative w-100 d-flex align-items-center flex-column"
                   @mouseenter="ViewOptions(true, index, 'add')" @mouseleave="ViewOptions(false, index, 'add')">
                <div class="" style="border: 1px gray dashed; height: 2rem;"/>

                <i v-if="showOptions.show && showOptions.index == index && showOptions.type == 'add'"
                   class="fad fa-plus position-absolute cursor-pointer text-primary bg-white fs-4 p-3 "
                   style=" color:red ; cursor: pointer; top: 15%; border-radius: 100%;"
                   @click="AddAction(item.ranking)"></i>
                <div class="" style="border: 1px gray dashed; height: 2rem;"/>

              </div>

              <div class="position-relative w-25 justify-content-center d-flex"
                   @mouseenter="ViewOptions(true, index, 'delete')" @mouseleave="ViewOptions(false, index, 'delete')">
                <button :key="index" :class="colorType(item)" class="btn " type="button" @click="EditAction(item)">
                  {{ reType(item) }}
                </button>
                <i v-if="showOptions.show && showOptions.index == index && showOptions.type == 'delete'" class="fad fa-trash  cursor-pointer  ms-3 fs-1"
                   style="right: 0; top: 10px; bottom: 0; color:red ; cursor: pointer;"
                   @click="DeleteAction(item.id)"></i>
              </div>
            </template>
          </template>
          <div class="mt-3" style="border: 1px gray dashed; height: 5rem;"/>
          <button v-b-modal.modal-action class="btn btn-secondary my-5" type="button">
            Ajouter une action
          </button>
        </div>


      </b-card>


      <b-modal id="modal-event" centered title="Assigner un evenement" @ok="handleOkEvent">
        <div>
          <div>
            <label for="event">Services</label>
            <select id="evenement" v-model="trigger.api" class="form-control form-select mt-3" @change="selectService">
              <option value=" null">Choisissez un service</option>
              <option v-for="api in apis" :value="api.code">CORE</option>
              <!--   <option value="form">FORM</option> -->
            </select>

          </div>


          <div v-if="events.length > 0 && trigger.api" class="mt-4">
            <label for="evenement">Évenements</label>
            <select id="evenement" v-model="trigger.event" class="form-control form-select mt-3" @change="configureTriggerParameters">
              <option value="null">Selectionnez un evenement</option>
              <template v-for="event in events">
                <option v-if="event.api.toUpperCase() === trigger.api.toUpperCase()" :value="event.code">
                  {{ event.name }}
                </option>
              </template>
            </select>
          </div>

          <div v-if="trigger.event" class="mt-4">
            <label for="evenement">Paramètres</label>
            <table class="table table-responsive table-striped mt-5">
              <tr v-for="param in trigger.parameters">
                <td>
                  {{ param.name }}
                </td>
                <td>
                  <input v-if="param.type == 'text'" v-model="param.value" class="form-control" type="text">
                  <input v-else-if="param.type == 'integer'" v-model="param.value" class="form-control" type="number">
                  <select v-if="param.type === 'branch'" class="form-control" v-model="param.value">
                    <option value="">Séléctionnez une branche</option>
                    <template v-for="category in branchCategories">
                      <option v-for="branch in category.branches" :key="branch.uuid" :value="branch.slug">{{ category.label }} - {{ branch.label }}</option>
                    </template>
                  </select>
                </td>
              </tr>
            </table>
          </div>

        </div>
      </b-modal>

      <b-modal id="modal-action" centered title="Ajouter une action" @cancel="cancel" @close="cancel" @ok="handleOkAction">
        <div v-if="!formAction.type" class="  text-center text-uppercase fw-bolder ">

          <div class="d-flex gap-5">
            <div class="bg-primary col-6 d-flex flex-column rounded text-white" @click="formAction.type = 'SEND_EMAIL'">
              <i class="fad fa-envelope text-white" style="font-size: 5rem"></i>
              <span class="mt-2"> Envoyer un mail </span>
            </div>

            <div class="bg-warning col-6 d-flex flex-column rounded" @click="formAction.type = 'SEND_SMS'">
              <i class="fad fa-sms" style="font-size: 5rem; color: black"></i>
              <span class="mt-2"> Envoyer un SMS </span>
            </div>
          </div>
          <div class="d-flex gap-5 mt-5">
            <div class="bg-success col-6 d-flex flex-column rounded" @click="sendWhatsapp">
              <i class="fab fa-whatsapp" style="font-size: 5rem; color: black"></i>
              <span class="mt-2"> Envoyer un Whatsapp </span>
            </div>

            <div class="bg-info col-6 d-flex flex-column rounded text-white" @click="formAction.type = 'WAIT'">
              <i class="fad fa-pause text-white" style="font-size: 5rem"></i>
              <span class="mt-2"> Attendre </span>
            </div>
          </div>
        </div>

        <div v-if="formAction.type == 'SEND_EMAIL'">
          <form>
            <div class="mb-3">
              <label class="form-label" for="emailTemplate">Utiliser un modele d'email</label>
              <select id="emailTemplate" v-model="formAction.emailTemplate" class="form-select">
                <option selected value="hours">Selectionnez un modele</option>
                <option v-for="(item, index) in modelEmailList" :key="index" :value="item">
                  {{ item.name }}
                </option>
              </select>
            </div>

            <!--
              <div class="border my-3" />

              <h4>Rediger le mail</h4>

              <div class="mb-3">
                <label for="object" class="form-label">Objet</label>
                <input type="text" class="form-control" id="object" />
              </div>

              <div>
                <label class="my-2">Ecrivez votre message</label>
                <div class="form-floating">
                  <textarea
                    v-model="message"
                    @input="onInput"
                    @keydown="onKeydown"
                    ref="suggestionArea"
                    class="form-control"
                    placeholder="Ecrivez votre message"
                    id="floatingTextarea2"
                    style="height: 100px"
                  ></textarea>
                  <label for="floatingTextarea2">Message</label>
                </div>

                <div v-if="showSuggestions" class="suggestions">
                  <ul>
                    <li
                      v-for="suggestion in filteredSuggestions"
                      :key="suggestion"
                      @click="addMention(suggestion)"
                    >
                      {{ suggestion }}
                    </li>
                  </ul>
                </div>
              </div>

  -->


          </form>
        </div>
        <div v-if="formAction.type == 'SEND_SMS'">
          <form>
            <div class="mb-3">
              <label class="form-label" for="exampleInputEmail1">Utiliser un modele d'SMS
              </label>
              <select id="inputGroupSelect01" v-model="formAction.smsTemplate" class="form-select">
                <option selected value="hours">Selectionnez un modele</option>
                <option v-for="(item, index) in modelSmsList" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </form>
        </div>
        <div v-if="formAction.type == 'WHATSAPP'">
          <form>
            <div class="mb-3">
              <label class="form-label" for="exampleInputEmail1">Utiliser un modele Whatsapp
              </label>
              <select id="inputGroupSelect01" v-model="formAction.whatsappTemplate.fid" class="form-select" @change="selectWhatsappTemplate">
                <option selected value="hours">Selectionnez un modele</option>
                <option v-for="(item, index) in templates" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <template>
              <div>
                Paramètres
              </div>
              <div class="mt-5">
                <b-tabs>
                  <b-tab :key="'trigger_'+trigger.id" v-for="trigger in campaign.triggers">
                    <template #title>
                      {{ trigger.api }}.{{ trigger.event }}
                    </template>
                    <div class="my-5">
                      <template v-for="(mapping, index) in formAction.whatsappTemplate.mappings">
                        {{ mapping.type }}
                        <div v-for="(param,pindex) in mapping.parameters" class="row my-2">
                          <div class="col-4 fw-bolder d-flex align-items-center">
                            {{ param.label }}
                          </div>
                          <div class="col d-flex align-items-center">
                            <input :id="'mapping_'+mapping.code+'_'+index+'_param_'+pindex" class="hidden mapping-switch" type="checkbox">
                            <select v-model="param.value" class="form-control form-select">
                              <template v-for="event in events">
                                <template v-if="trigger.event === event.code">
                                  <option value="null">
                                    Séléctionnez un paramètre
                                  </option>
                                  <option v-for="(type, key) in event.schema" :key="key" :value="key">
                                    {{ key }}
                                  </option>
                                </template>
                              </template>
                            </select>
                            <input v-model="param.value" class="form-control" placeholder="Valeur" type="text">
                            <label :for="'mapping_'+mapping.code+'_'+index+'_param_'+pindex" class="btn btn-primary btn-icon btn-sm ms-2">
                              <i class="fad fa-input-text"></i>
                            </label>
                          </div>
                        </div>
                      </template>

                    </div>
                  </b-tab>
                </b-tabs>

              </div>
            </template>
          </form>
        </div>
        <div v-if="formAction.type == 'WAIT'" class="d-flex flex-column">
          <label class="mb-3" for="time"> Temps d'attente : </label>

          <div class="input-group mb-3">
            <input v-model="timeData.time" aria-describedby="basic-addon1" class="form-control" type="number"/>
            <select id="inputGroupSelect01" v-model="timeData.type" class="form-select">
              <option selected value="minutes">Minutes</option>
              <option value="heures">Heures</option>
              <option value="jours">jours</option>
              <option value="semaines">Semaines</option>
              <option value="mois">Mois</option>
              <option value="années">Années</option>
            </select>
          </div>
        </div>
      </b-modal>


    </template>
  </Base>
</template>

<script lang="ts">
import Base from "@/layouts/Base.vue";
import {Component, Ref, Vue} from "vue-property-decorator";
import {api} from "@/services/Api";
import EmailTemplate from "@/entity/EmailTemplate";
import SmsTemplate from "@/entity/SmsTemplate";
import VFlowChart from "vue2-flow";
import Campaign from "@/entity/Campaign";
import Action from "@/entity/Action";
import {helper} from "@/services/Helper";
import Trigger from "@/entity/Trigger";
import WhatsappTemplate from "@/entity/WhatsappTemplate";

@Component({
  components: {Base, VFlowChart},
})
export default class CampaignCreate extends Vue {
  @Ref("suggestionArea") readonly suggestionArea!: any;
  @Ref("button-delete") readonly buttonDelete!: any;

  formAction = new Action();
  nodeEvent: any = null;
  nodeAction: any = null;
  event: any = null;
  events: any = [];
  message = "";
  suggestions: any = null;
  showSuggestions = false;
  filteredSuggestions: any[] = [];
  mentionStartIndex = -1;
  timeData = {
    time: 0,
    type: "heures",
  };
  modelEmailList: EmailTemplate[] = [];
  modelSmsList: SmsTemplate[] = [];
  campaign: Campaign = new Campaign();
  showOptions = {
    index: null,
    show: false,
    type: ''
  };
  templates: any[] = []
  template: any = null
  serviceSelected = null
  trigger = new Trigger()

  apis = [
    {name: 'Core', code: 'core', baseUrl: api.core}
  ]
  branchCategories: any[] = []

  sendWhatsapp() {
    this.formAction.type = 'WHATSAPP'
    this.formAction.whatsappTemplate = new WhatsappTemplate()
  }

  ViewOptions(show: boolean, index: any, type: string) {

    this.showOptions.index = index;
    this.showOptions.show = show;
    this.showOptions.type = type;

  }

  selectWhatsappTemplate() {
    if (helper.empty(this.formAction.whatsappTemplate)) {
      return
    }
    const template = this.templates.find((t: any) => {
      return t.id === this.formAction.whatsappTemplate.fid
    })
    if (template) {
      this.formAction.whatsappTemplate.name = template.name
      this.formAction.whatsappTemplate.mappings = []
      for (const component of template.components) {
        if (component.type.toLowerCase() === 'buttons') {

          this.campaign.triggers.forEach((trigger: any) => {
            component.buttons.forEach((b: any) => {
              console.log(b)
              const c = {type: 'BUTTON', parameters: [], trigger: trigger.id, url: b.url}
              const matches = [...b.url.matchAll(/{{(\d+)}}/g)];
              const indexes = [...new Set(matches.map(match => match[1]))];
              console.log(indexes)

              if (indexes.length > 0) {
                for (const idx of indexes) {
                  const p = {
                    label: `${b.text} – Param ${idx}`,
                    code: idx,
                    type: b.type,
                    value: null
                  }
                  c.parameters.push(p)
                }
                this.formAction.whatsappTemplate.mappings.push(c)
              }
              // if (b.example) {
              //   const p = {label: b.text, type: b.type,  value: null}
              //   c.parameters.push(p)
              // }
              // this.formAction.whatsappTemplate.mappings.push(c)

            })
          })
        }
        if (component.example) {
          const params = component.example.header_text_named_params ?? component.example.body_text_named_params
          const c = {type: component.type, parameters: [], trigger: ''}

          if (params) {
            this.campaign.triggers.forEach((trigger: any) => {
              c.trigger = trigger.id
              for (const param of params) {
                const p = {label: param.param_name, code: param.param_name, value: null}
                c.parameters.push(p)
              }
            })
            this.formAction.whatsappTemplate.mappings.push(c)
          }

        }
      }
    }
    // console.log(this.formAction.whatsappTemplate.mappings)
    this.$forceUpdate()
  }

  configureTriggerParameters() {
    if (this.trigger.event) {
      const event = this.events.find((e: any) => {
        return e.code === this.trigger.event
      })
      if (event) {
        this.trigger.type = event.type
        event.parameters.forEach((p: any) => {
          const index = this.trigger.parameters.findIndex((param: any) => {
            return param.code === p.code
          })
          if (index === -1) {
            this.trigger.parameters.push(p)
          }
        })
      }
    }
  }

  adjustRanking = (tasks: any[]) => {
    tasks.sort((a, b) => a.id + b.id);  // Ensure tasks are sorted by id
    tasks.forEach((task, index) => {
      task.ranking = index + 1;  // Update ranking to be continuous
    });


    return tasks;

    // console.log(tasks);

  };

  addTrigger() {
    this.trigger = new Trigger()
    this.trigger.campaign = {id: this.campaign.id} as Campaign
    this.$bvModal.show("modal-event");
  }

  editTrigger(trigger: Trigger) {
    this.trigger = trigger
    this.trigger.campaign = {id: this.campaign.id} as Campaign
    this.$bvModal.show("modal-event");

  }

  async DeleteAction(id: any) {

    this.$store.commit("loading");

    const index = this.campaign.actions.findIndex(task => task.id === id);

    if (index !== -1) {
      this.campaign.actions.splice(index, 1);
      this.adjustRanking(this.campaign.actions);
    }

    const resDelete = await api.delete(api.com, "action/delete/" + id);


    if (resDelete) {
      const res = await api.post(api.com, "campaign/edit", {
        campaign: this.campaign,
      });

      if (res) {
        this.$store.commit("stopLoading");
        this.campaign = res.data.campaign
        this.$forceUpdate()
      }

    }
  }

  async loadWhatsappTemplates() {
    if (this.templates.length > 0) {
      return
    }
    const res = await api.get(api.chat, 'whatsapp/template/list')
    if (res?.data?.templates) {
      this.templates = res.data.templates
    }
  }

  async AddAction(index: number) {
    this.$bvModal.show("modal-action");
    this.formAction = new Action()
    this.formAction.ranking = index
  }

  reType(item: Action) {
    if (item.type == "SEND_EMAIL") {
      return `Envoyer l'email ${item.emailTemplate.name}`
    } else if (item.type == "SEND_SMS") {
      return `Envoyer l'SMS ${item.smsTemplate.name}`
    } else if (item.type == "WHATSAPP") {
      return `Envoyer Whatsapp ${item.whatsappTemplate?.name}`
    } else {
      return `Attendre ${helper.ConvertTime(item.waitingTime)}`
    }

  }

  colorType(item: Action) {
    if (item.type == "SEND_EMAIL") {
      return `btn-primary`
    } else if (item.type == "SEND_SMS") {
      return `btn-warning`
    } else {
      return `btn-info`
    }

  }

  async loadBranches() {
    if (!helper.empty(this.branchCategories)) {
      return this.branchCategories
    }
    const res = await api.get(api.core, 'branch/list');
    if (res?.data.branches) {
      this.branchCategories = res.data.branches
    }
  }

  async loadEvents() {
    this.events = []
    for (const data of this.apis) {
      const res = await api.get(data.baseUrl, "custom/event/list");
      if (res?.data?.events) {
        this.events = this.events.concat(res.data.events);
        console.log(this.events[0].parameters[0].type)

      }
    }
  }

  async selectService(event: any) {
    // const service = event.target.value;
    // const apis: any = api
    // const resEvents = await api.get(apis[service], "custom/event/list");
    // this.events = resEvents.data.events;
    // this.serviceSelected = service

  }

  async handleOkEvent() {
    this.$bvModal.hide("modal-event");
    if (this.trigger.event) {
      // const serviceSelected: any = this.serviceSelected
      // const apis: any = api
      const res = await api.post(api.com, "trigger/edit", this.trigger);
      if (res?.data?.trigger) {
        res.data.trigger.campaign = {id: this.campaign.id, code: this.campaign.code, name: this.campaign.name} as Campaign
        await api.post(api[res.data.trigger.api], 'custom/event/subscription/add', res.data.trigger)
      }
    }


    this.$forceUpdate();
  }

  async handleOkAction() {

    this.$bvModal.hide("modal-action");

    if (this.formAction.type == "WAIT") {
      const time = this.convertToMinutes(
          this.timeData.time,
          this.timeData.type
      );
      this.formAction.waitingTime = time;


    }

    // if (this.formAction.type == "SEND_EMAIL") {
    //   this.nodeAction.name =
    //     "Envoyer le mail" + " " + this.formAction.emailTemplate.name;
    // }

    // if (this.formAction.type == "SEND_SMS") {
    //   this.nodeAction.name =
    //     "Envoyer l'SMS" + " " + this.formAction.smsTemplate.name;
    // }

    // if (this.formAction) {
    //   this.nodes[
    //     this.nodes.findIndex((item: any) => item.id == this.nodeAction.id)
    //   ] = this.nodeAction;
    //   // this.suggestions = this.events && Object.keys(this.event.schema);
    // }

    // this.formAction.ranking = this.campaign.actions.length

    const index = this.campaign.actions.findIndex(obj => obj.id === this.formAction.id);
    if (index !== -1) {
      this.campaign.actions[index] = this.formAction;
    } else {


      if (this.formAction.ranking !== 0) {
        this.campaign.actions.splice(this.formAction.ranking - 1, 0, this.formAction);
      } else {
        this.campaign.actions.push(this.formAction);
      }


    }
    const adjustRankingActions: Action[] = this.adjustRanking(this.campaign.actions)


    const campaign = {
      ...this.campaign,
      actions: adjustRankingActions
    }


    this.$store.commit("loading");

    const res =
        await api.post(api.com, "campaign/edit", {
          campaign: campaign,
        });
    if (res) {
      this.load()
    }

    const formAction = new Action();
    this.formAction = formAction;

    this.timeData = {
      time: 0,
      type: "heures",
    };

    // this.$forceUpdate();
  }

  EditAction(item: Action) {

    // let action = new Action()
    this.formAction = item
    if (item.type === 'WHATSAPP' && helper.empty(this.formAction.whatsappTemplate)) {
      this.formAction.whatsappTemplate = new WhatsappTemplate()
    }
    // this.formAction.id = item.id
    // this.formAction.ranking = item.ranking
    this.$bvModal.show("modal-action");
  }

  cancel() {
    const formAction = new Action();
    this.formAction = formAction;
    this.timeData = {
      time: 0,
      type: "heures",
    };
    this.$forceUpdate();
  }

  mounted() {
    this.load();
    this.loadWhatsappTemplates()
    this.loadEvents()
    this.loadBranches()

  }

  async load() {
    this.$store.commit("loading");
    const res = await api.get(
        api.com,
        "campaign/show/" + this.$route.params.id
    );

    const resEmailList = await api.get(api.com, "email/template/list");
    const resSmsList = await api.get(api.com, "sms/template/list");

    this.modelEmailList = resEmailList.data.templates;
    this.modelSmsList = resSmsList && resSmsList.data && resSmsList.data.templates ? resSmsList.data.templates : [];
    if (res && res.data) {
      this.campaign = new Campaign(res.data.campaign);
    }

    // if (this.campaign.mapping) {
    //   const mapping: any = this.campaign.mapping;
    //   this.nodes = mapping.nodes;
    //   this.conns = mapping.conns;
    //   this.addNewNode(this.nodes[this.nodes.length - 1], "Ajouter une etape");
    // }
    this.$store.commit("stopLoading");
  }

  convertToMinutes(number: number, type: string) {
    // console.log(type);
    const minutesPerHour = 60;
    const minutesPerDay = 24 * minutesPerHour;
    const minutesPerWeek = 7 * minutesPerDay;
    const minutesPerMonth = 30 * minutesPerDay; // approximation
    const minutesPerYear = 365 * minutesPerDay; // approximation

    switch (type.toLowerCase()) {
      case "minutes":
      case "minutes":
        return number;
      case "heures":
      case "hours":
        return number * minutesPerHour;
      case "jours":
      case "days":
        return number * minutesPerDay;
      case "semaines":
      case "weeks":
        return number * minutesPerWeek;
      case "mois":
      case "months":
        return number * minutesPerMonth;
      case "années":
      case "years":
        return number * minutesPerYear;
      default:
        throw new Error("Type de temps non valide");
    }
  }

  onInput(event: any) {
    const cursorPosition = event.target.selectionStart;
    const textBeforeCursor = this.message.slice(0, cursorPosition);

    const mentionMatch: any = textBeforeCursor.match(/@(\w*)$/);
    if (mentionMatch) {
      this.showSuggestions = true;
      this.filteredSuggestions = this.suggestions.filter((suggestion: any) =>
          suggestion.toLowerCase().includes(mentionMatch[1].toLowerCase())
      );
      this.mentionStartIndex = mentionMatch.index + 1;
    } else {
      this.showSuggestions = false;
    }
  }

  onKeydown(event: { key: string; preventDefault: () => void }) {
    if (this.showSuggestions && event.key === "Enter") {
      event.preventDefault();
      this.addMention(this.filteredSuggestions[0]);
    }
  }

  addMention(suggestion: any) {
    const cursorPosition = this.suggestionArea.selectionStart;
    const textBeforeCursor = this.message.slice(0, this.mentionStartIndex - 1);
    const textAfterCursor = this.message.slice(cursorPosition);
    const messageCode = `{{${suggestion}}}`;
    this.message = `${textBeforeCursor} ${messageCode} ${textAfterCursor}`;
    // this.message = this.message + suggestion;

    this.showSuggestions = false;
  }
}
</script>

<style>
.chart__container {
  height: 100%;
}

.mapping-switch:checked ~ select {
  display: none;
}

.mapping-switch:not(:checked) ~ input {
  display: none;
}

.chart__container > .chart__self {
  height: 100% !important;

  font-weight: bold;
  text-align: center;
}

.chart__container > .chart__self .node {
  cursor: pointer;
  border-radius: 2rem;
  overflow: hidden;
}
</style>
